module.exports = __webpack_public_path__ + "static/media/BBi Logo (1).3ca067c0.jpg";